/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, API_CONSTANTS, COMMON } from '../../global/Constants';
// import './krishak.css';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import Utilities from '../../global/Utilities';
import Select, { components } from 'react-select';
import GpsCoordinates from '../common/GpsCoordinates';
import Loader from "../common/loader/Loader";
import AddNumbers from '../common/AddNumbers';
//import AddImages from '../common/AddImages';
import AddNewImages from '../common/AddNewImages';

import ApiServices from '../../providers/ApiServices';
import { ActivityStatusType } from '../../global/Enum';
import DataProvider from '../../providers/DataProvider';
import SyncServices from '../../providers/SyncServices';
import AuthService from '../../providers/AuthService';
import SyncLoader from '../common/loader/SyncLoader';

const Menu = props => {
    const optionSelectedLength = props.getValue().length || 0;
    return (
        <components.Menu {...props}>
            {optionSelectedLength < props.selectProps.maxLength ? (
                props.children
            ) : (
                <div style={{ margin: 15 }}>Max limit achieved</div>
            )}
        </components.Menu>
    );
};

class EditGroupMeeting extends Component {

    constructor(props) {
        super(props)
        this.goBack = this.goBack.bind(this);
        this.state = {
            isLoading: false,
            mobileNumber: "",
            data: {},
            seasonData: [],
            subActivityData: [],
            retailerData: [],
            prerakData: [],
            selectedSeason: 0,
            selectedSeasonObject: null,
            selectedSubActivity: null,
            selectedRetailers: [],
            selectedPreraks: [],
            remarks: "",
            farmerCount: "",
            retailerCount: "",
            prerakCount: "",
            isFarmerChecked: false,
            isRetailerChecked: false,
            isPrerakChecked: false,
            farmerCommitment: "",
            weight_unit_id: 1,
            farmerNumbers: [],
            farmerNumbersImages: [],
            regexp: /^[0-9]/,
            krishakInfo: null,
            latitude: null,
            longitude: null,
            farmerNumbersImageFiles: [],
            isDisableFarmerInfo: false,
            group_meeting_images: []
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state) {
                const krishakInfo = this.props.location.state.krishakInfo;


                this.setState({
                    data: this.props.location.state.data,
                    isDisableFarmerInfo: krishakInfo === null ? true : false
                }, () => {
                    this.getGroupMeetingParamApi(this.state.data);
                    // if (this.state.data?.activity_status_id === ActivityStatusType.TO_RESUBMIT) {
                    //     this.getActivityById(this.state.data.key);
                    //     this.getKrishakById(this.state.data.krishak_id);
                    // }
                })

            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    getAvailableMobileNumber = () => {
        this.setState({ isLoading: true });
        var params = JSON.stringify({
            activity_id: this.state.data?.activity_id,
        });
        try {
            ApiServices.getAvailableMobileNumber(params)
                .then(response => {
                    this.setState({ isLoading: false });
                    var status = response.success;
                    if (status) {
                        this.setState({
                            mobileNumber: response.data.reporting_mobile
                        })
                    } else {
                        alert(response.message);
                    }
                })
                .catch(error => {
                    this.setState({ isLoading: false });
                });
        }
        catch (error) {
            this.setState({ isLoading: false });
        }
    }

    goBack() {
        this.props.history.goBack();
    }

    /* Check Mark Unselect Reset Values Prerak & Retailer */
    prerakRef = null;
    retailerRef = null;

    clearPrerakValue() {
        this.prerakRef.select.clearValue();
    };

    clearRetailerValue() {
        this.retailerRef.select.clearValue();
    };

    handleFarmerCheckbox = () => {
        this.setState({
            isFarmerChecked: !this.state.isFarmerChecked,
        });
    }

    handleRetailerCheckbox = () => {
        if (this.state.isRetailerChecked) {
            this.clearRetailerValue()
        }
        this.setState({
            isRetailerChecked: !this.state.isRetailerChecked, selectedRetailers: []
        });
    }

    handlePrerakCheckbox = () => {
        if (this.state.isPrerakChecked) {
            this.clearPrerakValue()
            this.setState({
                isPrerakChecked: !this.state.isPrerakChecked,
            });
        } else {
            this.setState({ isPrerakChecked: !this.state.isPrerakChecked });
        }
    }

    onFarmerCountChange = e => {
        let count = e.target.value;
        if (count === '' || this.state.regexp.test(count)) {
            this.setState({ farmerCount: count })
        }
    }

    onRetailerCountChange = e => {
        let count = e.target.value;
        if (count === '' || this.state.regexp.test(count)) {
            this.setState({ retailerCount: count })
        }
    }

    onPrerakCountChange = e => {
        let count = e.target.value;
        if (count === '' || this.state.regexp.test(count)) {
            this.setState({ prerakCount: count })
        }
    }

    viewKrishakInfo = () => {
        const { krishakInfo } = this.state;
        Utilities.LogPrint("krishakInfo", krishakInfo);
        this.props.history.push({
            pathname: ALL_ROUTES.KRISHAK_INFO_ROUTE,
            state: { krishak_id: krishakInfo.krishak_id === 0 ? krishakInfo.temp_krishak_id : krishakInfo.krishak_id }
            //state: { krishak_id: this.state.krishakInfo.krishak_id }
        });

        // this.props.history.push({
        //     pathname: ALL_ROUTES.KRISHAK_INFO_ROUTE,
        //     state: { krishak_id: this.state.krishakInfo.krishak_id }
        // });
    }

    handleSeason = selectedSeason => {
        this.setState({
            selectedSeason,
            selectedSubActivity: null
        }, () => {
            this.getSubActivities(selectedSeason?.season_id);
        })
    };

    getSubActivities(seasonId) {
        const { seasonData } = this.state;
        const seasonLists = seasonData.find(item => item.season_id === seasonId);
        if (seasonLists) {
            const subActivities = seasonLists?.sub_activity ?? [];
            if (subActivities !== null && subActivities.length > 0) {
                const subActivityArray = subActivities.map(({ sub_activity_id: value, sub_activity_name: label, ...rest }) => ({ value, label, ...rest }));
                this.setState({
                    subActivityData: subActivityArray,
                })
            }
        }
    }



    // getSubActivities(selectedSeasonId) {
    //     SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_SUB_ACTIVITY, SYNC_SERVICE.MASTER_TABLE).then(data => {
    //         if (data && data !== undefined && data.length > 0) {
    //             var filterData = [];
    //             for (var i = 0; i < data.length; i++) {
    //                 if (data[i].season_id === selectedSeasonId && data[i].activity_type_id === ActivityType.GROUP_MEETING && data[i].crop_id === this.state.data.crop_id) {
    //                     filterData.push(data[i]);
    //                 }
    //             }
    //             this.setState({
    //                 subActivityData: filterData.map(({ sub_activity_id: value, sub_activity_name: label, ...rest }) => ({ value, label, ...rest }))
    //             });
    //         }
    //     });
    // }

    handleSubActivityChange = selectedSubActivity => {
        this.setState({ selectedSubActivity });
    };

    handleRetailerChange = selectedRetailers => {
        let array = [];
        selectedRetailers.forEach(element => {
            let retailer = {
                retailer_id: element.value,
                label: element.label,
                commitment: element.commitment,
                weight_unit_id: 1
            };
            array.push(retailer)
        })
        this.setState({ selectedRetailers: array });
    };

    handlePrerakChange = selectedPreraks => {
        let array = [];
        selectedPreraks.forEach(element => {
            let prerak = {
                prerak_id: element.value,
                label: element.label,
                commitment: element.commitment,
                weight_unit_id: 1
            };
            array.push(prerak)
        })
        this.setState({ selectedPreraks: array });
    };

    handleNumbers = (numbers) => {
        this.setState({ farmerNumbers: numbers });
    }

    handleNumberImages = (images, selectedFiles) => {
        this.setState({ farmerNumbersImages: images, farmerNumbersImageFiles: selectedFiles }, () => {
            Utilities.LogPrint("farmerNumbersImages", this.state.farmerNumbersImages);
        });
    }

    // handleAddImages = (e, images, selectedFiles) => {
    //     //Utilities.LogPrint("Images", images);
    //     //Utilities.LogPrint("Selected - Images File - >", selectedFiles);
    //     this.setState({ images: images, imageFiles: selectedFiles }, () => {
    //         Utilities.LogPrint("Images", this.state.images);
    //     });
    // }

    handleAddImages = (images) => {
        this.setState({ group_meeting_images: images }, () => {
            Utilities.LogPrint("Images", this.state.group_meeting_images);
        });
    }

    getCoordinates = (latLng) => {
        this.setState({
            latitude: latLng.latitude,
            longitude: latLng.longitude
        })
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleRetailerCommitmentChange = (i, item) => e => {
        const { selectedRetailers } = this.state;
        let markers = [...selectedRetailers];
        markers[i] = { ...markers[i], commitment: e.target.value };
        this.setState({ selectedRetailers: markers })
    };

    handlePrerakCommitmentChange = (i, item) => e => {
        const { selectedPreraks } = this.state;
        let markers = [...selectedPreraks];
        markers[i] = { ...markers[i], commitment: e.target.value };
        this.setState({ selectedPreraks: markers })
    };

    isFormValid() {
        const { seasonData, selectedSubActivity, selectedRetailers, selectedPreraks, group_meeting_images } = this.state;
        // return seasonData === null || selectedSubActivity === null || selectedRetailers === null || selectedPreraks === null || latitude === null || longitude === null || images ?.length === 0 || images === undefined;
        return seasonData === null || selectedSubActivity === null || selectedRetailers === null || selectedPreraks === null || group_meeting_images?.length === 0 || group_meeting_images === undefined;
    }

    //API CALLS
    getGroupMeetingParamApi = (data) => {
        var params = JSON.stringify({
            activity_id: data.activity_id
        });
        try {
            ApiServices.getActivityById(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        Utilities.LogPrint("getActivityById123", response.data);
                        let data = response.data;
                        let groupMeetingFarmerPhone = response.data.group_meeting_farmer_phone;
                        const propsData = this.props.location.state.data;
                        Utilities.LogPrint("propsData123", propsData);
                        data.crop_name = propsData.crop_name
                        data.hybrid_name = propsData.hybrid_name
                        data.village_name = propsData.village_name
                        data.activity_tag = propsData.activity_tag
                        data.crop_id = propsData.crop_id
                        data.key = propsData.key
                        data.activity_type_id = propsData.activity_type_id

                        let retailerCommitmentObj = [];

                        for (let i = 0; i < this.state.retailerData.length; i++) {
                            for (let j = 0; j < data.retailer_commitment.length; j++) {
                                if (data.retailer_commitment[j].retailer_id === this.state.retailerData[i].value) {
                                    let found = this.state.retailerData[i];
                                    found.commitment = data.retailer_commitment[j].commitment
                                    found.retailer_id = data.retailer_commitment[j].retailer_id
                                    found.weight_unit_id = data.retailer_commitment[j].weight_unit_id
                                    retailerCommitmentObj.push(found);
                                }
                            }
                        }

                        let prerakCommitmentObj = [];

                        for (let i = 0; i < this.state.prerakData.length; i++) {
                            for (let j = 0; j < data.prerak_commitment.length; j++) {
                                if (data.prerak_commitment[j].prerak_id === this.state.prerakData[i].value) {
                                    let found = this.state.prerakData[i];
                                    found.commitment = data.prerak_commitment[j].commitment
                                    found.prerak_id = data.prerak_commitment[j].prerak_id
                                    found.weight_unit_id = data.prerak_commitment[j].weight_unit_id
                                    prerakCommitmentObj.push(found);
                                }
                            }
                        }
                        this.getSubActivities(data.group_meeting?.season_id);
                        let objSubActivity = data.group_meeting?.sub_activity
                        objSubActivity.value = data.group_meeting?.sub_activity.sub_activity_id
                        objSubActivity.label = data.group_meeting?.sub_activity.sub_activity_name

                        //For Krishak & Host Farmer
                        let krishakInfo = {
                            krishak_id: 0,
                            name: '',
                            phone: ''
                        }
                        if (response?.data?.krishak) {
                            krishakInfo.krishak_id = response?.data?.krishak.krishak_id;
                            krishakInfo.name = response?.data?.krishak.name;
                            krishakInfo.phone = response?.data?.krishak.phone;
                        } else {
                            if (response?.data?.group_meeting?.host_name) {
                                krishakInfo.name = response?.data?.group_meeting?.host_name;
                                krishakInfo.phone = response?.data?.group_meeting?.host_phone;
                            }
                        }

                        this.setState({
                            data: data,
                            selectedSeason: data?.group_meeting?.season,
                            selectedSubActivity: objSubActivity,
                            isRetailerChecked: (data.retailer_commitment.length > 0) ? true : false,
                            isPrerakChecked: (data.prerak_commitment.length > 0) ? true : false,
                            isFarmerChecked: (data.group_meeting.is_farmer_attend === 1) ? true : false,
                            farmerCount: data.group_meeting.no_farmer_attend,
                            retailerCount: data.retailer_commitment.length,
                            prerakCount: data.prerak_commitment.length,
                            farmerCommitment: data.group_meeting.farmer_commitment,
                            selectedRetailers: retailerCommitmentObj,
                            selectedPreraks: prerakCommitmentObj,
                            farmerNumbers: groupMeetingFarmerPhone.map(({ phone_image: phone, ...rest }) => ({ phone, ...rest })),
                            farmerNumbersImages: data.group_meeting_farmer_image.map(({ phone_image: image_url, group_meeting_farmer_id: krishak_fellow_farmer_image_id, ...rest }) => ({ image_url, krishak_fellow_farmer_image_id, ...rest })),
                            //krishakInfo: response.data.krishak,
                            krishakInfo: krishakInfo,
                            remarks: data.group_meeting.remark,
                            group_meeting_images: data.group_meeting_image.map(({ image: image_url, group_meeting_farmer_id: image_id, ...rest }) => ({ image_url, image_id, ...rest })),
                            //isDisableFarmerInfo: response.data.krishak === null ? true : false,
                            isDisableFarmerInfo: krishakInfo?.krishak_id === 0 ? false : true
                        })
                    } else {
                        Utilities.LogPrint("Status", response.message);
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                    this.setState({ isLoading: false });
                })
                .catch(error => {
                    Utilities.LogPrint("getActivityById-catch", error);
                });
        }
        catch (error) {
            //this.props.loaderCallback(false);
            Utilities.LogPrint("getActivityById-error", error);
        }

        this.setState({
            mobileNumber: data?.reporting_mobile
        });

        const retailers = DataProvider.getInstance().getRetailers();
        if (retailers) {

            let retailerArray = [];
            for (var i = 0; i < retailers.length; i++) {
                let data1 = retailers[i];
                retailerArray.push({
                    value: data1.retailer_id,
                    label: data1.retailer_shop_name + "(" + data1.phone + ")"
                });
            }

            // const retailerArray = retailers ?.map(({ retailer_id: value, retailer_name: label, ...rest }) => ({ value, label, ...rest }));
            Utilities.LogPrint("Retailers:-", retailerArray);
            this.setState({
                retailerData: retailerArray
            })
        };

        // Seasons
        const seasons = DataProvider.getInstance().getCropSeasonSubActivities(data.crop_id, data.activity_type_id);
        //Utilities.LogPrint("Seasons Data =>", items);
        if (seasons !== null) {
            this.setState({ seasonData: seasons })
        }

        // SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_SEASON, SYNC_SERVICE.MASTER_TABLE).then(data => {
        //     Utilities.LogPrint("season", data);
        //     if (data && data !== undefined && data.length > 0) {
        //         let seasonData = [];

        //         for (var i = 0; i < data.length; i++) {
        //             let data1 = data[i];
        //             if (data1.is_active === 1) {
        //                 seasonData.push(data1);
        //             }
        //         }

        //         this.setState({ seasonData });
        //     }
        // });

        SyncServices.getKrishakFromDatabase("is_prerak", "true").then(data => {
            if (data && data !== undefined && data.length > 0) {
                let preraks = [];
                for (var i = 0; i < data.length; i++) {
                    let data1 = data[i].data;
                    preraks.push({
                        value: data1.krishak_id,
                        label: data1.name + "(" + data1.phone + ")"
                    });
                }
                this.setState({
                    prerakData: preraks,
                });
            } else {
                // this.getActivityById(this.state.data.key);
                // this.getKrishakById(this.state.data.krishak_id);

                // if (this.state.data) {
                //     if (this.state.data.temp_krishak_id === undefined) {
                //         this.getActivityById(this.state.data.key);
                //     } else {
                //         this.getActivityById(this.state.data.temp_krishak_id);
                //     }
                // }
            }
        });
    }

    fileToByteArray(file) {
        return new Promise((resolve, reject) => {
            try {
                let reader = new FileReader();
                let fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = (evt) => {
                    if (evt.target.readyState === FileReader.DONE) {
                        let arrayBuffer = evt.target.result,
                            array = new Uint8Array(arrayBuffer);
                        for (var i = 0; i < array.length; i++) {
                            fileByteArray.push(array[i]);
                        }
                    }
                    resolve(fileByteArray);
                }
            }
            catch (e) {
                reject("Choose a File");
            }
        })
    }


    handleSubmitButton = async () => {
        const { data, krishakInfo, farmerNumbersImageFiles, selectedSeason, isFarmerChecked, isRetailerChecked, isPrerakChecked, farmerCount, retailerCount, prerakCount, selectedSubActivity, selectedRetailers, selectedPreraks, farmerCommitment, remarks, latitude, longitude, farmerNumbers,
            group_meeting_images } = this.state;

        let farmer_numbers = [];
        for (var i = 0; i < farmerNumbers.length; i++) {
            if (farmerNumbers[i].phone !== undefined) {
                // farmer_numbers[i].phone = farmerNumbers[i].FarmerNumber
                farmer_numbers.push({ phone: farmerNumbers[i].phone })
            }
        }

        let group_meeting_farmer_images = [];
        if (farmerNumbersImageFiles !== undefined) {
            for (let i = 0; i < farmerNumbersImageFiles.length; i++) {
                let image1 = farmerNumbersImageFiles[i];
                let byteArray = await this.fileToByteArray(image1.file);
                group_meeting_farmer_images.push({ byteArray });
            }
        }

        Utilities.LogPrint('#11', group_meeting_images);
        Utilities.LogPrint('#22', farmerNumbersImageFiles);

        const session = AuthService.getSession();
        const isTMLogin = session?.user.role_id === 3 ? true : false;

        let group_meeting = {
            key: data.key,
            activity_id: data.activity_id,
            activity_type_id: data?.activity_type_id,
            activity_status_id: isTMLogin ? ActivityStatusType.COMPLETED : ActivityStatusType.PENDING_REVIEW,
            krishak_id: (krishakInfo) ? krishakInfo.krishak_id : data.krishak_id,
            season_id: selectedSeason?.season_id,
            season: selectedSeason,
            sub_activity_id: selectedSubActivity.value,
            sub_activity: selectedSubActivity,
            is_farmer_attend: isFarmerChecked,
            no_farmer_attend: farmerCount,
            is_retailer_attend: isRetailerChecked,
            no_retailer_attend: retailerCount,
            is_prerak_attend: isPrerakChecked,
            no_prerak_attend: prerakCount,
            farmer_commitment: farmerCommitment,
            weight_unit_id: 1,
            prerak_commitment: selectedPreraks,
            retailer_commitment: selectedRetailers,
            group_meeting_image: group_meeting_images,
            group_meeting_farmer_image: farmerNumbersImageFiles,
            group_meeting_farmer_phone: farmer_numbers,
            remark: remarks,
            latitude: latitude,
            longitude: longitude,
            farmerNumbersImageFiles: farmerNumbersImageFiles,
            reporting_mobile: (this.state.mobileNumber && this.state.mobileNumber.length !== 0 && this.state.mobileNumber !== undefined) ? this.state.mobileNumber : ""
        }


        Utilities.LogPrint("Save Request: -> ", group_meeting);

        // If User Online
        if (Utilities.isNetworkConnected() && data?.activity_id > 0) {
            const formData = new FormData();
            formData.append("activity_id", data.activity_id);
            // formData.append("temp_activity_id", data.key);
            // formData.append("activity_date", data.created_at);
            formData.append("activity_type_id", data?.activity_type_id);
            formData.append("krishak_id", (krishakInfo) ? krishakInfo.krishak_id : data.krishak_id);
            formData.append("season_id", selectedSeason?.season_id);
            formData.append("crop_id", data?.crop_id);
            formData.append("reporting_mobile", data?.reporting_mobile);
            formData.append("hybrid_id", data?.hybrid_id);
            formData.append("village_id", data?.village_id);
            formData.append("assigned_user_id", data?.assigned_user_id);
            formData.append("sub_activity_id", selectedSubActivity.value);
            formData.append("is_farmer_attend", isFarmerChecked);
            formData.append("no_farmer_attend", farmerCount);
            formData.append("is_retailer_attend", isRetailerChecked);
            formData.append("no_retailer_attend", retailerCount);
            formData.append("is_prerak_attend", isPrerakChecked);
            formData.append("no_prerak_attend", prerakCount);
            formData.append("farmer_commitment", farmerCommitment);
            formData.append("weight_unit_id", 1);
            formData.append("retailer_commitment", JSON.stringify(selectedRetailers));
            formData.append("prerak_commitment", JSON.stringify(selectedPreraks));
            formData.append("group_meeting_farmer_phone", JSON.stringify(farmer_numbers));
            formData.append("latitude", latitude);
            formData.append("longitude", longitude);
            formData.append("remark", remarks);
            formData.append("activity_status_id", isTMLogin ? ActivityStatusType.COMPLETED : ActivityStatusType.PENDING_REVIEW)

            for (let i = 0; i < farmerNumbersImageFiles.length; i++) {
                formData.append("group_meeting_farmer_image", farmerNumbersImageFiles[i].file);
            }

            // For Images
            let group_meeting_image = [];
            for (let i = 0; i < group_meeting_images.length; i++) {
                const objImage = group_meeting_images[i];
                if (objImage.file !== undefined && objImage.file != null)
                    group_meeting_image.push(objImage.file);

            }

            for (let i = 0; i < group_meeting_image.length; i++) {
                formData.append("group_meeting_image", group_meeting_image[i]);
            }

            this.setState({ isLoading: true });
            try {
                ApiServices.editActivity(formData)
                    .then(response => {
                        Utilities.LogPrint("API_DATA: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {
                            //const data = response.data;
                            SyncServices.editActivity(group_meeting, "true");
                            this.goBack();
                            // if (data != null) {

                            // }
                        } else {
                            Utilities.LogPrint("Status", response.message);
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false });
            }
        } else {
            this.goBack();
        }
    }

    getKrishakById = (krishak_id) => {
        SyncServices.findKrishakFromDatabase("krishak_id", String(krishak_id)).then(data => {
            if (data) {
                if (data.is_active === undefined || data.is_active === null || data.is_active === 1) {
                    const krishakInfo = data;
                    this.setState({
                        krishakInfo,
                        isDisableFarmerInfo: krishakInfo === null ? true : false
                    });
                } else {
                    //this.checkKrishakOffline(krishak_id);
                }
            }
        });
    }

    deleteGroupMeetingImageApi = (item) => {
        var params = JSON.stringify({
            group_meeting_image_id: item.group_meeting_image_id,
        });
        try {
            ApiServices.deleteGroupMeetingImage(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        Utilities.LogPrint("deleteGroupMeetingFarmerImageApi", response.message);
                    }
                    else {
                        this.setState({ isLoading: false });
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("deleteGroupMeetingFarmerImageApi-catch", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("deleteGroupMeetingFarmerImageApi-error", error);
        }
    }

    deleteGroupMeetingFarmerImageApi = (item) => {
        var params = JSON.stringify({
            group_meeting_farmer_id: item.id,
        });
        try {
            ApiServices.deleteGroupMeetingFarmerImage(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        Utilities.LogPrint("deleteGroupMeetingFarmerImageApi", response.message);
                    }
                    else {
                        this.setState({ isLoading: false });
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("deleteGroupMeetingFarmerImageApi-catch", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("deleteGroupMeetingFarmerImageApi-error", error);
        }
    }

    async getByteArray(myFile, name) {
        let byteArray = await this.fileToByteArray(myFile);
        return {
            byteArray, name
        }
    }

    handleSyncLoading = (loading, tableName) => {
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {

        const { isLoading, isSyncLoading, data, mobileNumber, seasonData, selectedSeason, subActivityData, retailerData, prerakData, selectedSubActivity, selectedRetailers, selectedPreraks, isFarmerChecked, isRetailerChecked, isPrerakChecked, farmerCount, retailerCount, prerakCount, farmerCommitment, remarks, krishakInfo, farmerNumbers,
            farmerNumbersImages, isDisableFarmerInfo, group_meeting_images } = this.state;
        const { tableName } = this.state;
        const seasonLists = seasonData.map((item, i) => {
            if (selectedSeason?.season_id === item.season_id) {
                return (
                    <div className="d-flex flex-wrap radiobox-container-row" key={i}>
                        <div className="radiobox-container radiobox-w-50">
                            <input type="radio" name="radio1" checked onClick={() => this.handleSeason(item)} />
                            <span className="checkmark w-250">{item.season_name}</span>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="d-flex flex-wrap radiobox-container-row" key={i}>
                        <div className="radiobox-container radiobox-w-50">
                            <input type="radio" name="radio1" onClick={() => this.handleSeason(item)} />
                            <span className="checkmark w-250">{item.season_name}</span>
                        </div>
                    </div>
                )
            }

        });

        const retailersLists = selectedRetailers.map((item, i) => {
            return (
                <div className="form-group acre-form-group row align-items-center" key={i}>
                    <div className="col-6 col-lg-3">
                        <label className="font-weight-medium mb-0">{(item.label !== undefined) ? item?.label?.split('(', 2)[0] : ""}</label>
                    </div>
                    <div className="col-6 col-lg-9">
                        <div className="form-control">
                            <input type="text" placeholder="Commitment" value={item?.commitment} onChange={this.handleRetailerCommitmentChange(i, item)} />
                            <span>kg</span>
                        </div>
                    </div>
                </div>
            )
        });


        const prerakLists = selectedPreraks.map((item, i) => {
            return (
                <div className="form-group acre-form-group row align-items-center" key={i}>
                    <div className="col-6 col-lg-3">
                        <label className="font-weight-medium mb-0">{item?.label?.split('(', 2)[0]}</label>
                    </div>
                    <div className="col-6 col-lg-9">
                        <div className="form-control">
                            <input type="text" placeholder="Commitment" value={item?.commitment} onChange={this.handlePrerakCommitmentChange(i, item)} />
                            <span>kg</span>
                        </div>
                    </div>
                </div>
            )
        });

        let getKrishakPhoneNo = "+91 - " + krishakInfo?.phone;

        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />

                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <div className="activity-info-box blue-activity text-white mb-3">
                                <span>{data.activity_tag}</span>
                                {(mobileNumber?.length > 0) ? <span style={{ position: 'absolute', top: 5, right: 20, alignItems: 'center' }} className="fod-desc d-flex">
                                    <i className="customic mobile-icon1 mr-1"></i>
                                    {mobileNumber}
                                </span> : <button onClick={this.getAvailableMobileNumber} className="btn btn-secondary w-50 mr-2 get-number">Get Number</button>}

                                <h5>Group Meeting</h5>
                                <span>{data.crop_name + ", " + data.hybrid_name + " | " + data.village_name}</span>
                            </div>
                        </div>
                    </div>

                    <div className="individual-visit-farmer">
                        {/* Input Farmer and Mobile Number */}
                        <div className={`row`}>

                            <div className="col-12 col-md-5 col-lg-4">
                                <div className="form-group mb-md-0">
                                    <input type="text" className="form-control max-w-360" placeholder="Farmer Name" value={krishakInfo?.name} disabled />
                                </div>
                            </div>
                            <div className="col-12 col-md-5 col-lg-4">
                                <div className="form-group mb-md-0">
                                    <input type="text" className="form-control" placeholder="" disabled value={getKrishakPhoneNo} />
                                </div>
                            </div>

                        </div>

                        <div className={`row ${!isDisableFarmerInfo ? 'd-none' : ''}`}>
                            <div className="col-12 col-md-5 col-lg-4">
                                <a className="d-flex align-items-center my-3" onClick={this.viewKrishakInfo}>
                                    {COMMON.VIEW_DETAILED_FARMER_INFORMATION} <i className="customic ic-info-black ml-auto"></i>
                                </a>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group mb-0">
                                    <label className="font-weight-medium mt-2">Stage of Visit</label>
                                    {seasonLists}
                                </div>
                            </div>

                            <div className="col-lg-8">
                                <div className="form-group">
                                    <label className="font-weight-medium mt-2">Sub Activity</label>
                                    <Select className="mb-3 max-w-360"
                                        value={selectedSubActivity}
                                        onChange={this.handleSubActivityChange}
                                        options={subActivityData}
                                        placeholder="Select any one"
                                        isClearable={true}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <label className="font-weight-medium">Attended by</label>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-12 col-md-4 mb-3 mb-md-0">
                                            <div className="row align-items-center">
                                                <div className="col-6 max-w-160">
                                                    <label className="cutom-checkbox-container mb-0 mb-md-3">
                                                        Farmer
                                                        <input type="checkbox" checked={isFarmerChecked} onChange={this.handleFarmerCheckbox} />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div className="col-6 pl-md-0">
                                                    <input type="number" className="form-control" placeholder="0" value={farmerCount} disabled={!isFarmerChecked} onChange={this.onFarmerCountChange} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4 mb-3 mb-md-0">
                                            <div className="row align-items-center">
                                                <div className="col-6">
                                                    <label className="cutom-checkbox-container mb-0 mb-md-3">
                                                        Retailer
                                                        <input type="checkbox" checked={isRetailerChecked} onChange={this.handleRetailerCheckbox} />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div className="col-6 pl-md-0">
                                                    <input type="number" className="form-control" placeholder="0" value={retailerCount} disabled={!isRetailerChecked} onChange={this.onRetailerCountChange} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="row align-items-center">
                                                <div className="col-6">
                                                    <label className="cutom-checkbox-container mb-0 mb-md-3">
                                                        {COMMON.PRERAK}
                                                        <input type="checkbox" checked={isPrerakChecked} onChange={this.handlePrerakCheckbox} />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div className="col-6 pl-md-0">
                                                    <input type="number" className="form-control" placeholder="0" value={prerakCount} disabled={!isPrerakChecked} onChange={this.onPrerakCountChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-5 mt-0 mt-md-3">
                                {/* Farmers Commitment in Kgs */}
                                {isFarmerChecked ?
                                    <div className="form-group acre-form-group row align-items-center">
                                        <div className="col-6 col-lg-3 ">
                                            <label className="font-weight-medium mb-0">Farmers</label>
                                        </div>
                                        <div className="col-6 col-lg-9">
                                            <div className="form-control">
                                                <input type="text" placeholder="Commitment" name="farmerCommitment" value={farmerCommitment} onChange={this.changeHandler} />
                                                <span>kg</span>
                                            </div>
                                        </div>
                                    </div>
                                    : null}


                                {/* Retailer Dropdown */}
                                {isRetailerChecked ?
                                    <div className="form-group row align-items-center">
                                        <div className="col-12 col-lg-3">
                                            <label className="font-weight-medium mb-0">Retailer</label>
                                        </div>
                                        <div className="col-12 col-lg-9">
                                            <Select className="mb-3 max-w-360"
                                                isMulti
                                                value={selectedRetailers}
                                                options={retailerData}
                                                onChange={this.handleRetailerChange}
                                                placeholder="Select who attended"
                                                maxLength={retailerCount}
                                                components={{ Menu }}
                                                ref={ref => {
                                                    this.retailerRef = ref;
                                                }}
                                            />
                                        </div>
                                    </div>
                                    : null}

                                {/* Retailer Commitment in Kgs */}
                                {retailersLists}

                                {/* Prerak Dropdown */}
                                {isPrerakChecked ?
                                    <div className="form-group row align-items-center">
                                        <div className="col-12 col-lg-3">
                                            <label className="font-weight-medium mb-0">{COMMON.PRERAK}</label>
                                        </div>
                                        <div className="col-12 col-lg-9">
                                            <Select className="mb-3 max-w-360"
                                                isMulti
                                                value={selectedPreraks}
                                                options={prerakData}
                                                onChange={this.handlePrerakChange}
                                                placeholder="Select who attended"
                                                maxLength={prerakCount}
                                                components={{ Menu }}
                                                ref={ref => {
                                                    this.prerakRef = ref;
                                                }}
                                            />
                                        </div>
                                    </div>
                                    : null}

                                {/* Prerak Commitment in Kgs */}
                                {prerakLists}
                            </div>


                            {/* Add Farmer Mobile Number */}
                            <div className="col-lg-12">
                                {/* <AddNumbers onAddNumber={this.handleNumbers} onAddNumberImages={this.handleNumberImages} /> */}
                                <AddNumbers images={farmerNumbersImages} farmerNumbers={farmerNumbers} onAddNumber={this.handleNumbers} onAddNumberImages={this.handleNumberImages} onDeleteImageApi={this.deleteGroupMeetingFarmerImageApi} />
                            </div>

                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="font-weight-medium mt-2">Remarks  <span className="font-weight-normal">(if any)</span></label>
                                    <textarea className="form-control" rows="6"
                                        name="remarks" value={remarks} onChange={this.changeHandler}></textarea>
                                </div>
                            </div>

                        </div>

                        {/* Add Images */}
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <AddImages imagePaths={images} handleAddImages={this.handleAddImages} deleteActivityImageApi={this.deleteGroupMeetingImageApi} /> */}
                                <AddNewImages handleAddImages={this.handleAddImages} images={group_meeting_images} />
                            </div>
                        </div>

                        {/* GPS Co-ordinates */}
                        <GpsCoordinates getCoordinates={this.getCoordinates} />

                        <div className="row">
                            <div className="col-12 d-flex button-grp-bottom">
                                <button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn" onClick={() => { this.goBack() }}>{COMMON.CANCEL}</button>
                                <button className="btn btn-primary w-50" onClick={this.handleSubmitButton} disabled={this.isFormValid()}>{COMMON.SUBMIT}</button>
                            </div>
                        </div>

                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
            </div>
        )
    }
}
export default withRouter(EditGroupMeeting)